import { render, staticRenderFns } from "./EmailDocs.vue?vue&type=template&id=49bcde1d&scoped=true"
import script from "./EmailDocs.vue?vue&type=script&lang=ts"
export * from "./EmailDocs.vue?vue&type=script&lang=ts"
import style0 from "./EmailDocs.vue?vue&type=style&index=0&id=49bcde1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bcde1d",
  null
  
)

export default component.exports